import { Switch } from "@material-tailwind/react";
import React from "react";

const SwitchResponseReview = ({ id, isChecked, handleChange }) => {
  return (
    <Switch
      color="green"
      id={id}
      checked={isChecked}
      ripple={true}
      onChange={(event) => handleChange(event.target.checked, id)}
      className="bg-red-600"
      label={isChecked ? <p>Accepted</p> : <p>Rejected</p>}
    />
  );
};

export default SwitchResponseReview;
